// Vendor
import { EventEmitter, SimpleChanges } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
// Services
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from '../../services/securities.service';
// Directives
import { HoldingsTableDirective } from '../../directives/holdings-table.directive';
// Utils & constants
import { getFormatter } from 'NewAngular/utils/number_formatter';
import { ALL_HOLDINGS, COMPARISON_TABLE_HEADER_DROPDOWN_CONFIG, EXPORT_HOLDINGS_OPTION, INTERSECT_ALL_HOLDINGS, INTERSECT_COMMON_HOLDINGS, INTERSECT_UNIQUE_HOLDINGS, REMOVE_COMPARABLE_OPTION, SAVE_AS_WATCHLIST_OPTION, } from 'SecuritiesApp/ts/constants/holdings-table.constants';
import { formatUTCDateString } from 'Core/redesign/utils/date';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "../../services/securities.service";
import * as i3 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/cascading-dropdown/cascading-dropdown.component";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i6 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i8 from "../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i9 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i10 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i11 from "../module-upsell/module-upsell.component";
import * as i12 from "../holdings-date-picker-inline/holdings-date-picker-inline.component";
function HoldingsComparisonTableComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ycn-holdings-date-picker-inline", 16);
    i0.ɵɵlistener("dateChangeHandler", function HoldingsComparisonTableComponent_ng_container_4_Template_ycn_holdings_date_picker_inline_dateChangeHandler_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleDateChange($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("dateOptions", ctx_r1.validHoldingDates)("initialSelectedDate", ctx_r1.currentHoldingDate)("inputDisabled", ctx_r1.intersectOption != "allHoldings");
} }
function HoldingsComparisonTableComponent_ng_container_7_div_1_tr_26_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 38);
} if (rf & 2) {
    const holding_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", holding_r4.url, i0.ɵɵsanitizeUrl)("text", holding_r4.ticker);
} }
function HoldingsComparisonTableComponent_ng_container_7_div_1_tr_26_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "--");
    i0.ɵɵelementEnd();
} }
function HoldingsComparisonTableComponent_ng_container_7_div_1_tr_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtemplate(2, HoldingsComparisonTableComponent_ng_container_7_div_1_tr_26_a_2_Template, 1, 2, "a", 35)(3, HoldingsComparisonTableComponent_ng_container_7_div_1_tr_26_span_3_Template, 2, 0, "span", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "td", 36)(5, "td", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const holding_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", holding_r4.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !holding_r4.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", holding_r4.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", holding_r4.current_weight);
} }
function HoldingsComparisonTableComponent_ng_container_7_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "ycn-module-upsell", 19);
    i0.ɵɵelementStart(2, "div", 20)(3, "div", 21)(4, "div", 22)(5, "div", 23);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 24);
    i0.ɵɵlistener("click", function HoldingsComparisonTableComponent_ng_container_7_div_1_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.pageChangeHandler(ctx_r1.PAGE_CONTROLS.PREV, ctx_r1.intersectOption, ctx_r1.getComparableIds())); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "span", 26);
    i0.ɵɵlistener("click", function HoldingsComparisonTableComponent_ng_container_7_div_1_Template_span_click_9_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.pageChangeHandler(ctx_r1.PAGE_CONTROLS.NEXT, ctx_r1.intersectOption, ctx_r1.getComparableIds())); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 25);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(11, "div", 27);
    i0.ɵɵelementStart(12, "div", 20)(13, "table", 28)(14, "thead", 29)(15, "tr", 30)(16, "th", 31);
    i0.ɵɵlistener("click", function HoldingsComparisonTableComponent_ng_container_7_div_1_Template_th_click_16_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.setTableSortProperties("ticker", ctx_r1.intersectOption, ctx_r1.getComparableIds())); });
    i0.ɵɵelementStart(17, "span", 32);
    i0.ɵɵtext(18, " Symbol ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "th", 31);
    i0.ɵɵlistener("click", function HoldingsComparisonTableComponent_ng_container_7_div_1_Template_th_click_19_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.setTableSortProperties("name", ctx_r1.intersectOption, ctx_r1.getComparableIds())); });
    i0.ɵɵelementStart(20, "span", 32);
    i0.ɵɵtext(21, " Name ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "th", 33);
    i0.ɵɵlistener("click", function HoldingsComparisonTableComponent_ng_container_7_div_1_Template_th_click_22_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.setTableSortProperties("current_weight", ctx_r1.intersectOption, ctx_r1.getComparableIds())); });
    i0.ɵɵelementStart(23, "span", 32);
    i0.ɵɵtext(24, " %\u00A0Weight ");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(25, "tbody");
    i0.ɵɵtemplate(26, HoldingsComparisonTableComponent_ng_container_7_div_1_tr_26_Template, 6, 4, "tr", 34);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r1.title.length > 0 ? ctx_r1.title : ctx_r1.comparable.name + " Holdings");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate3("", ctx_r1.paginationInfo.start_index, "-", ctx_r1.paginationInfo.end_index, " of ", ctx_r1.paginationInfo.num_items, " Securities");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.pageNum === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-back");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.pageNum >= ctx_r1.paginationInfo.num_pages);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-collapse");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortNgClass("ticker"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortNgClass("name"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r1.getSortNgClass("current_weight"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.formattedHoldings);
} }
function HoldingsComparisonTableComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HoldingsComparisonTableComponent_ng_container_7_div_1_Template, 27, 12, "div", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.loading);
} }
function HoldingsComparisonTableComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.noHoldingsMessage);
} }
function HoldingsComparisonTableComponent_ycn_loading_symbol_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 40);
} }
/**
 * HoldingsComparisonTableComponent.
 *
 * Holdings table for Comparables tab. It has a dropdown menu with options to save the comparable as watchlist,
 * export it, and remove the pane.
 *
 * Required Attributes:
 *      @ comparable: Main comparable security.
 *      @ enableDropdownMenu: Enable dropdown menu for main comparable.
 *      @ removeComparableHandler: Handler for the remove pane action.
 */
export class HoldingsComparisonTableComponent extends HoldingsTableDirective {
    constructor(featuresService, securitiesService) {
        super(featuresService, securitiesService);
        this.featuresService = featuresService;
        this.securitiesService = securitiesService;
        this.title = '';
        this.disableRemoveFromMenu = false;
        this.removeComparableHandler = new EventEmitter();
        this.intersectOption = INTERSECT_ALL_HOLDINGS;
        this.comparableSecurities = [];
        this.showHoldingsDate = true;
        this.showNoHoldingsMessage = false;
        this.noHoldingsMessage = '';
        this.actionsDropdownConfig = cloneDeep(COMPARISON_TABLE_HEADER_DROPDOWN_CONFIG);
    }
    ngOnInit() {
        this.securityId = this.comparable.securityId;
        if (this.type === ALL_HOLDINGS) {
            this.evaluateHoldingDates();
        }
        this.getHoldings(this.intersectOption, this.getComparableIds());
        this.noHoldingsMessage = this.getNoHoldingsMessage();
        if (this.disableRemoveFromMenu) {
            this.actionsDropdownConfig.list.pop();
        }
    }
    ngOnChanges(changeObj) {
        if (changeObj.intersectOption) {
            // reset datepicker initial date if user changes intersect option
            if (this.type === ALL_HOLDINGS) {
                this.evaluateHoldingDates();
            }
            // retrieve holdings again if user changes intersect option
            this.intersectOption = changeObj.intersectOption.currentValue;
            this.getHoldings(this.intersectOption, this.getComparableIds());
        }
        if (changeObj.comparableSecurities || changeObj.holdingsLayer) {
            // retrieve holdings again if user changes the comparable securities
            this.getHoldings(this.intersectOption, this.getComparableIds());
        }
    }
    getNoHoldingsMessage() {
        if (this.intersectOption === INTERSECT_UNIQUE_HOLDINGS) {
            return 'No unique holdings found';
        }
        if (this.intersectOption === INTERSECT_COMMON_HOLDINGS) {
            return 'No common holdings found';
        }
        return 'No holdings found';
    }
    getComparableIds() {
        return this.comparableSecurities.map((security) => security.securityId);
    }
    /**
     * Formats the holdings list, specifically the value for current weight.
     *
     * @param holdings: Holdings list.
     */
    formatHoldings(holdings) {
        const valFormatter = getFormatter('percent');
        return holdings.map((holding) => {
            const formattedHolding = { ...holding };
            const currentWeight = formattedHolding.current_weight;
            formattedHolding.current_weight = currentWeight ? valFormatter(currentWeight, 2) : '--';
            return formattedHolding;
        });
    }
    /**
     * Handler for the pane dropdown menu.
     *
     * @param option: Selected option.
     */
    selectDropdownOption(option) {
        switch (option) {
            case SAVE_AS_WATCHLIST_OPTION:
                this.saveAsWatchlist(this.intersectOption, this.getComparableIds());
                break;
            case EXPORT_HOLDINGS_OPTION:
                this.exportHoldingDataUrl(this.currentHoldingDate ? formatUTCDateString(this.currentHoldingDate) : '', this.intersectOption, this.getComparableIds());
                break;
            case REMOVE_COMPARABLE_OPTION:
                this.removeComparableHandler.emit(this.comparable);
                break;
            default:
                break;
        }
    }
    evaluateHoldingDates() {
        this.securitiesService.getAllHoldingDates(this.securityId).subscribe({
            next: (response) => {
                this.validHoldingDates = response.holding_dates.map((dateString) => new Date(dateString));
                [this.currentHoldingDate] = this.validHoldingDates;
            },
        });
    }
}
HoldingsComparisonTableComponent.ɵfac = function HoldingsComparisonTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsComparisonTableComponent)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.SecuritiesService)); };
HoldingsComparisonTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsComparisonTableComponent, selectors: [["ycn-holdings-comparison-table"]], inputs: { comparable: "comparable", title: "title", disableRemoveFromMenu: "disableRemoveFromMenu", intersectOption: "intersectOption", comparableSecurities: "comparableSecurities", showHoldingsDate: "showHoldingsDate", showNoHoldingsMessage: "showNoHoldingsMessage" }, outputs: { removeComparableHandler: "removeComparableHandler" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 19, vars: 10, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title", 3, "textContent"], ["data-test-id", "Date Picker Panel", 1, "panel-actions"], [4, "ngIf"], [1, "panel-action", "dropdown"], ["buttonClass", "options-handler btn btn-xs btn-circle btn-transparent", "dropdownClass", "dropdown-menu-right dropdown-menu-with-icons", 3, "handler", "showDropdownCaret", "config"], ["class", "get-started border-0 pt-10", 4, "ngIf"], ["loaderMessage", "Loading Data...", 4, "ngIf"], [3, "closeModalHandler", "extraModalClasses", "open"], ["header", "Save as Watchlist", 3, "closeModalHandler"], [1, "modal-body"], [1, "modal-section", "section-info", 3, "textContent"], [1, "modal-footer", "user-select-none"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], [3, "dateChangeHandler", "dateOptions", "initialSelectedDate", "inputDisabled"], ["class", "panel-scroll", 4, "ngIf"], [1, "panel-scroll"], [3, "title"], [1, "panel-content"], [1, "panel-pagination"], [1, "panel-pagination-content"], [1, "panel-pagination-count", "text-small", "mr-auto"], ["ycnDisabled", "", 1, "btn", "btn-text", "disabled", 3, "click", "disabled"], ["ycnIcon", "", 3, "name"], ["ycnDisabled", "", 1, "btn", "btn-text", 3, "click", "disabled"], [1, "divider-horizontal"], [1, "table"], [2, "cursor", "pointer", "user-select", "none"], ["data-test-id", "Column Headers"], [3, "click", "ngClass"], [2, "padding-top", "0", "padding-bottom", "0"], [1, "colTxtShort", "text-right", 3, "click", "ngClass"], [4, "ngFor", "ngForOf"], [3, "href", "text", 4, "ngIf"], [3, "textContent"], [1, "text-right", 3, "textContent"], [3, "href", "text"], [1, "get-started", "border-0", "pt-10"], ["loaderMessage", "Loading Data..."]], template: function HoldingsComparisonTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelement(2, "h3", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, HoldingsComparisonTableComponent_ng_container_4_Template, 2, 3, "ng-container", 4);
        i0.ɵɵelementStart(5, "div", 5)(6, "ycn-cascading-dropdown", 6);
        i0.ɵɵlistener("handler", function HoldingsComparisonTableComponent_Template_ycn_cascading_dropdown_handler_6_listener($event) { return ctx.selectDropdownOption($event); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(7, HoldingsComparisonTableComponent_ng_container_7_Template, 2, 1, "ng-container", 4)(8, HoldingsComparisonTableComponent_div_8_Template, 3, 1, "div", 7)(9, HoldingsComparisonTableComponent_ycn_loading_symbol_9_Template, 1, 0, "ycn-loading-symbol", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "ycn-modal-base", 9);
        i0.ɵɵlistener("closeModalHandler", function HoldingsComparisonTableComponent_Template_ycn_modal_base_closeModalHandler_10_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(11, "ycn-simple-modal-header", 10);
        i0.ɵɵlistener("closeModalHandler", function HoldingsComparisonTableComponent_Template_ycn_simple_modal_header_closeModalHandler_11_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵelement(13, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 13)(15, "div", 14)(16, "div", 15);
        i0.ɵɵlistener("click", function HoldingsComparisonTableComponent_Template_div_click_16_listener() { return ctx.closeModal(); });
        i0.ɵɵtext(17, " Close ");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(18, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("textContent", ctx.title.length > 0 ? ctx.title : ctx.comparable.name + " Holdings");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.currentHoldingDate && ctx.showHoldingsDate);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("showDropdownCaret", false)("config", ctx.actionsDropdownConfig);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.formattedHoldings.length > 0 || !ctx.showNoHoldingsMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !(ctx.formattedHoldings.length > 0) && ctx.showNoHoldingsMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.showSaveAsWatchlistResult);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("textContent", ctx.saveAsWatchlistResult);
    } }, dependencies: [i3.CascadingDropdownComponent, i4.NgClass, i4.NgForOf, i4.NgIf, i5.DisabledDirective, i6.FeatureNeededComponent, i7.IconDirective, i8.LoadingSymbolComponent, i9.ModalBaseComponent, i10.SimpleModalHeaderComponent, i11.ModuleUpsellComponent, i12.HoldingsDatePickerInlineComponent], encapsulation: 2 });
